export function validateTemplateIsSermonclipTemplate(template) {
    const node = document.createElement('div');
    node.innerHTML = template;
    const sermonclip = node.querySelector('[data-amelement="sermonclip"]');
    if (!sermonclip)
        return false;
    return true;
}
